import { useIntersectionObserver } from "../hooks/useIntersectionObserver";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PricingHeader from "@/components/pricing/PricingHeader";
import PricingCard from "@/components/pricing/PricingCard";
import FeatureComparisonChart from "@/components/pricing/FeatureComparisonChart";
import CostComparison from "@/components/CostComparison";
import PricingReviews from "@/components/pricing/PricingReviews";
import { Button } from "@/components/ui/button";
import { useState } from "react";

const Pricing = () => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  });

  const [isAnnual, setIsAnnual] = useState(true);
  const savingsPercent = 19; // Assuming this is the savings percentage

  const features = [
    "Unlimited projects",
    "Priority support",
    "Advanced analytics",
    "Custom integrations",
    "Team collaboration",
    "API access",
    "Dedicated account manager",
  ];

  return (
    <div className="min-h-screen bg-surface">
      <Navbar />
      <PricingHeader 
        title="Simple, transparent\npricing"
        description="Everything you need to streamline your workflow."
      />
      
      <div className="container mx-auto px-4 mb-24">
        <div 
          ref={ref}
          className={`max-w-7xl mx-auto transition-all duration-500 transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="lg:bg-white lg:rounded-xl lg:md:rounded-2xl lg:overflow-hidden relative">
            {/* Badge for desktop view - shown only in the lg breakpoint and above */}
            {isAnnual && (
              <div className="hidden lg:block absolute top-0 right-0 bg-green-500 text-white px-4 py-1 rounded-tr-xl rounded-bl-lg text-sm font-medium shadow-md z-10">
                Save {savingsPercent}%
              </div>
            )}
            <div className="flex flex-col lg:flex-row">
              <div className="order-2 lg:order-1 w-full lg:w-1/3 bg-[#104B60] p-3 sm:p-4 md:p-8 mt-8 lg:mt-0 rounded-xl lg:rounded-none">
                <CostComparison />
              </div>
              
              <div className="order-1 lg:order-2 w-full lg:w-2/3 p-3 sm:p-4 md:p-8">
                <PricingCard
                  features={features}
                  className="border shadow-sm lg:border-none lg:shadow-none h-full"
                  showSavingsBadge={true} // Only show on mobile now
                  isAnnual={isAnnual}
                  onToggleIsAnnual={(value) => setIsAnnual(value)}
                  savingsPercent={savingsPercent}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <FeatureComparisonChart />
      
      <PricingReviews />
      <div className="mt-8 mb-16 mx-auto px-4 md:px-6 max-w-[1200px]">
        <div className="w-full border-2 border-[#27B5FC] bg-[#27B5FC] rounded-xl md:rounded-2xl">
          <div className="text-center space-y-4 md:space-y-6 p-6 md:p-8">
            <h2 className="text-4xl md:text-6xl font-charter font-medium text-white leading-tight">
              Ready to get<br />started today?
            </h2>
            <Button 
              className="w-full md:w-auto bg-[#FAF9F8] hover:bg-[#104B60] text-black hover:text-white px-4 md:px-6 py-3 md:py-4 text-base md:text-lg h-auto rounded-full transition-colors"
              onClick={() => window.location.href = 'https://app.plannifi.com/auth/sign-up'}
            >
              Sign up for free
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Pricing;
